import React, { useCallback } from "react";
import { Checkbox as AntCheckbox } from "antd";
import classnames from "classnames";
import styles from "./checkbox.module.scss";
import lang from "translations";

const Checkbox = ({ value, onChange, name, disabled, loading, className }) => {
  const onChangeCb = useCallback(
    (e) => {
      if (onChange) {
        onChange(name, {
          value: !value,
        });
      }
    },
    [name, value, onChange]
  );
  return (
    <AntCheckbox
      loading={loading}
      className={classnames(className, styles.container)}
      indeterminate={value === lang.indeterminate}
      disabled={disabled}
      checked={value === lang.indeterminate ? null : value}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onChange={onChangeCb}
    />
  );
};

export default Checkbox;
